/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Gratitude_Body3Inputs */

const en_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We will always keep this gratitude close to our hearts.`)
};

const ar_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنحتفظ بهذا الامتنان في قلوبنا دائماً.`)
};

const de_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir werden diese Dankbarkeit immer in unseren Herzen bewahren.`)
};

const es_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siempre llevaremos esta gratitud en nuestros corazones.`)
};

const fr_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette gratitude restera à jamais gravée dans nos cœurs.`)
};

const it_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserveremo sempre questa gratitudine nel cuore.`)
};

const ja_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この感謝の気持ちは、これからもずっと大切にしていきます。`)
};

const ko_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 고마움을 항상 가슴 깊이 간직할게요.`)
};

const pt_br_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nós sempre guardaremos essa gratidão em nossos corações.`)
};

const ru_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы всегда будем хранить эту благодарность в своих сердцах.`)
};

const th_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราจะจดจำความขอบคุณนี้ไว้ในหัวใจตลอดไป`)
};

const tr_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu minnettarlığı her zaman kalbimizde saklayacağız.`)
};

const zh_cn_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这份感动我们一直放在心上`)
};

const zh_tw_pro_user_appreciation_letter_gratitude_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這份感動我們一直放在心上`)
};

/**
* | output |
* | --- |
* | "We will always keep this gratitude close to our hearts." |
*
* @param {Pro_User_Appreciation_Letter_Gratitude_Body3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_gratitude_body3 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Gratitude_Body3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Gratitude_Body3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_gratitude_body3(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_gratitude_body3(inputs)
	return zh_tw_pro_user_appreciation_letter_gratitude_body3(inputs)
});